module.exports = __webpack_public_path__ + "static/donationbox-cb3cfd07f89f39e913221f39bad6d3b1.png";